export default __webpack_public_path__ + "static/media/product-image-hover-3.2cc658f8.jpg";